<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px; flex-wrap: wrap;">
                    <el-input v-model="formDatas.acrCode" style="width: 120px;" size="mini"
                        placeholder="劵码" clearable></el-input>
                    <el-input v-model="formDatas.acrAmount" style="width: 100px;" size="mini"
                        placeholder="劵面金额" clearable></el-input>
                    <el-date-picker v-model="formDatas.acrYearMonth" type="month" placeholder="选择年月"
                        style="width: 130px;" size="mini" clearable value-format="yyyyMM"
                        @change="partserch"></el-date-picker>
                    <el-select v-model="formDatas.acrCodeType" placeholder="请选择券码类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="烟感" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.billShareType" placeholder="请选择分账类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="折扣67%" :value="1"></el-option>
                        <el-option label="折扣77%" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.acrStatus" placeholder="请选择状态" style="width: 140px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="已撤销" :value="0"></el-option>
                        <el-option label="创建" :value="1"></el-option>
                        <el-option label="第三方导入" :value="2"></el-option>
                        <el-option label="第三方领取" :value="3"></el-option>
                        <el-option label="已核销" :value="4"></el-option>
                        <el-option label="分账" :value="5"></el-option>
                        <el-option label="退款" :value="6"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="warning" size="mini" icon="el-icon-download" @click="handleExport"
                        style="margin-left: 10px">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordSubList } from "../../api/api";
export default {
    name: "CertificateRecordSub",
    components: {},
    data() {
        return {
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrCode",
                    key: "acrCode",
                    title: "劵码",
                    align: "center",
                    width: 180,
                },
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "劵面金额(元)",
                    align: "center",
                },
                {
                    field: "acrYearMonth",
                    key: "acrYearMonth",
                    title: "年月",
                    align: "center",
                },
                {
                    field: "acrCodeType",
                    key: "acrCodeType",
                    title: "劵码类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrCodeType == 1) {
                            return '普通'
                        } else if (row.acrCodeType == 2) {
                            return '烟感'
                        } else if (row.acrCodeType == 3) {
                            return '类型3'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "billShareType",
                    key: "billShareType",
                    title: "分账类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.billShareType == 1) {
                            return '折扣67%'
                        } else if (row.billShareType == 2) {
                            return '折扣77%'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrStatus == 0) {
                            return '已撤销'
                        } else if (row.acrStatus == 1) {
                            return '创建'
                        } else if (row.acrStatus == 2) {
                            return '第三方导入'
                        } else if (row.acrStatus == 3) {
                            return '第三方领取'
                        } else if (row.acrStatus == 4) {
                            return '已核销'
                        } else if (row.acrStatus == 5) {
                            return '分账'
                        } else if (row.acrStatus == 6) {
                            return '退款'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "createTime",
                    key: "h",
                    title: "创建时间",
                    width: 160,
                    align: "center",
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
            totalCount: 100,
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleExport() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-sub/exportAjefCertificateRecordSub',
                data: s,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'user': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '未领取的券.xlsx');
                    a.click();
                    that.$message({
                        message: "导出成功",
                        type: "success"
                    });
                }
            })
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getAjefCertificateRecordSubList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefCertificateRecordSubList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        getList() {
            getAjefCertificateRecordSubList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
